export * from './ProposalDetail';
